<template lang="pug">
.transcript-toc(v-if="rootNode")
  h2 {{ $t('transcriptToc.toc') }}
  section-switch
  hr
  p.warning(v-if="!sectionHasPage") {{ $t('transcriptToc.contextWarning') }}
  h3 {{ rootNode.title }}
  ul.main-toc.is-collapsible
    navigable-toc-item(v-for="(child, index) in rootNode.contents" :key="index" :model="child" :level="1")
.transcript-toc(v-else)
  h2 {{ $t('transcriptToc.noToc') }}
  section-switch
</template>

<script>
import SectionSwitch from "../SectionSwitch";
import NavigableTocItem from "./NavigableTocItem";

const { data, sectionHasPage } = require("../../toc");
const { messages } = require("../../i18n/toc")

export default {
    name: "TranscriptToc",
    components: {
        NavigableTocItem,
        SectionSwitch
    },
    i18n: { messages },
    computed: {
        sectionHasPage: function() {
            const pageId = this.$route.params.id;
            const section = this.$route.params.section;
            return sectionHasPage({ section: section, page: pageId});
        },

        rootNode() {
            return data({ section: [this.section] });
        },

        section() {
            return this.$route.params.section;
        }
    },

    methods: {

        pathToPage({ id }) {
            return `/seite/${this.section}/${id}`;
        }
    }
}
</script>